import { Injectable } from '@angular/core';
import { Http, Response, Headers, RequestOptions } from '@angular/http';
import { ProjectInfo } from '../projects/projectinfo';
import { Observable } from 'rxjs/Rx';
import { AuthHttp, AuthConfig } from 'angular2-jwt';

import * as globals from '../globals';

@Injectable()
export class ShapeSearchService {
  private projectsUrl = globals.APIURL + '/projects';
  private shapesearchUrl = this.projectsUrl + '/shapesearch';
  private ssGetProjectsUrl = this.shapesearchUrl + '/projects';
  constructor(private http: Http, public authHttp: AuthHttp) { }

  shapeSearch(vizseekguid: string, tenantid: string): Observable<string> {
    console.log('shapeSearch service method called');

    let body = JSON.stringify({ vizseekguid: vizseekguid, tenantid: tenantid });
    let headers = new Headers({
      'Content-Type': 'application/json'
    });
    let options = new RequestOptions({ headers: headers });
    // console.log('URL =>', this.translateUrl);
    // console.log('BODY =>', body);
    // console.log('OPTIONS =>', options);
    return this.authHttp.post(this.shapesearchUrl, body, options)
      .map(this.extractData)
      .catch(this.handleError);
  }

  ssGetProjects(tenantid: string, matches: any): Observable<string> {
    console.log('ssGetProjects service method called');

    let body = JSON.stringify({ tenantid: tenantid, matches: matches });
    let headers = new Headers({
      'Content-Type': 'application/json'
    });
    let options = new RequestOptions({ headers: headers });
    // console.log('URL =>', this.translateUrl);
    // console.log('BODY =>', body);
    // console.log('OPTIONS =>', options);

    return this.authHttp.post(this.ssGetProjectsUrl, body, options)
      .map(this.extractData)
      .catch(this.handleError);
  }

  private extractData(res: Response) {
    let body = res.json();
    // console.log('BODY:', body);
    return body || {};
  }

  handleError(error: any) {
    // In a real world app, we might use a remote logging infrastructure
    // We'd also dig deeper into the error to get a better message
    let errMsg = (error.message) ? error.message :
      error.status ? `${error.status} - ${error.statusText}` : 'Server error';
    console.error('CAUGHT AN ERROR:', errMsg); // log to console instead
    // CAUGHT AN ERROR: No JWT present or has expired
    return Observable.throw(errMsg);
  }
}



// WEBPACK FOOTER //
// /Users/mark/Documents/Source/MachineResearch/MR2/angular2/src/app/shapesearch/shapesearch.service.ts